/**
 * Normalize a website string to a fully qualified URL.
 *
 * - Adds `https://` if missing.
 * - Adds `www.` only if the hostname has no subdomain.
 * - Returns `null` for invalid or non-domain inputs.
 */
export const normalizeWebsiteUrl = (website: string) => {
  if (!website) return null;

  // make sure we dont have floating spaces on either side
  let value = website.trim();
  if (!value) return null;

  // if it doesn't have http or https we add https
  if (!/^https?:\/\//i.test(value)) {
    value = `https://${value}`;
  }

  try {
    const url = new URL(value);
    const { hostname } = url;

    // removes input like "notawebpage"
    if (!hostname.includes(".")) return null;

    const parts = hostname.split(".");

    // adds www if there is no subdomain so "meow.com" => "www.meow.com"
    if (parts.length === 2 && !hostname.startsWith("www.")) {
      url.hostname = `www.${hostname}`;
    }

    return url.href;
  } catch {
    return null;
  }
};

// Pluralize a word
// Overcast the plural variable to change it
export const pluralize = (count: number, word: string, plural: string = "s") =>
  `${count} ${word}${count === 1 ? "" : plural}`;
